
const location2tspdata = ({ csvarray }) => {
  var teleportation_distance_sheet = [];
  var teleportation_tsp = {};
  var points = [];


  teleportation_distance_sheet = csvarray;
  teleportation_tsp["test"] = "test";


  for (var i = 1; i < teleportation_distance_sheet.length; i++) {
    var dict = { "id": i - 1, "name": teleportation_distance_sheet[i][1] };
    points.push(dict);
  }
  teleportation_tsp["points"] = points;

  var values = [];
  for (i = 1; i < teleportation_distance_sheet.length; i++) {
    for (var j = 1; j < teleportation_distance_sheet.length; j++) {
      if (i != j) {
        var x1 = teleportation_distance_sheet[i][2];
        var y1 = teleportation_distance_sheet[i][3];
        var x2 = teleportation_distance_sheet[j][2];
        var y2 = teleportation_distance_sheet[j][3];
        var dict2 = { "from": teleportation_distance_sheet[i][1], "to": teleportation_distance_sheet[j][1], "set": [i - 1, j - 1], "value": Math.sqrt((Number(x2) - (Number(x1))) ** 2 + (Number(y2) - (Number(y1))) ** 2) }
        values.push(dict2);
      }


    }

  }

  teleportation_tsp["values"] = values;

  return { result: teleportation_tsp };



}

export default location2tspdata